import React, { Component } from 'react';

import Photosphere from './Photosphere';

import 'bootstrap/dist/css/bootstrap.css';
import { Button, PageHeader, Panel } from 'react-bootstrap';
import FaIconDropbox from 'react-icons/lib/fa/dropbox';
import './App.css';

import demoPhotosphere from './demo.jpg';
import hypercube from './hypercube.gif';

class PhotosphereContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderClassNames: "fadeIn",
            photosphereClassNames: "hidden"
        };

        this.showPhotosphere = this.showPhotosphere.bind(this);
    }

    showPhotosphere() {
        this.setState({
            loaderClassNames: "fadeOut",
            photosphereClassNames: "fadeIn"
        });
    }

    showLoader() {
        this.setState({
            loaderClassNames: "fadeIn",
            photosphereClassNames: "hidden"
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.src !== this.props.src) {
            this.showLoader();
        }
    }

    render() {
        return (
          <div id="PhotosphereContainer">
            <div id="Loader">
              <img src={hypercube} className={this.state.loaderClassNames} alt="presentation" />
            </div>
            <div id="PhotosphereInnerContainer" className={this.state.photosphereClassNames}>
              <Photosphere src={this.props.src} onComplete={this.showPhotosphere} />
            </div>
          </div>
        );
    }
}

class DropboxChooserLauncher extends Component {
    render() {
        return (
          <Panel id="DropboxChooserLauncher">
            <Button bsSize="large" bsStyle="primary" disabled={this.props.isChoosing} onClick={!this.props.isChoosing ? this.props.handleClick : null}>
              <FaIconDropbox size={24} color="white" />
              {this.props.isChoosing ? 'Choosing...' : 'Choose image from Dropbox'}
            </Button>
          </Panel>
        );
    }
}

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            src: demoPhotosphere,
            isChoosing: false
        };

        this.handleDropboxChooserClick = this.handleDropboxChooserClick.bind(this);
        this.loadPhotosphere = this.loadPhotosphere.bind(this);
    }

    loadPhotosphere(files) {
        const src = files[0].link;

        this.setState({
            src: src,
            isChoosing: false
        });
    }

    handleDropboxChooserClick() {
        this.setState({
            isChoosing: true
        });
        window.Dropbox.choose({
            success: this.loadPhotosphere,
            cancel: () => { this.setState({ isChoosing: false }); },
            linkType: "direct",
            multiselect: false,
            extensions: ['.jpg', '.jpeg']
        });
    }

    render() {
        return (
                <div id="App">
                  <Panel>
                    <PageHeader>Welcome to the AppearSphere
                <DropboxChooserLauncher isChoosing={this.state.isChoosing} handleClick={this.handleDropboxChooserClick} />
                </PageHeader>
                  </Panel>
                  <Panel id="PhotosphereOuterContainer">
                    <PhotosphereContainer src={this.state.src}/>
                  </Panel>
                </div>
        );
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/